export enum DocumentAnalysisProofOfAddressDocumentTypesEnum {
  energy_bill = 'energy_bill',
  telco_bill = 'telco_bill',
  official_document = 'official_document',
  // Fallback
  other = 'other',
}
